import {isEditorMobileVariant} from '@Components/poster-editor/library/is-editor-mobile-variant';
import {MobilePageSelectionModeState} from '@Components/poster-editor/poster-editor.types';
import {setMobilePageSelectionModeState} from '@Components/poster-editor/poster-editor-reducer';
import {openPosterEditorPageOptionsModal} from '@Modals/poster-editor-page-options-modal/poster-editor-page-options-modal.types';
import {isPageNavigationBlocked} from '@PosterWhiteboard/libraries/poster-page-navigation-guard.library';

export const transitionToMobilePageSelectionMode = (): void => {
  if (!isEditorMobileVariant()) {
    return;
  }

  const areMultiPagesEnabledForUser = window.PMW.isMultipageAvailable;
  if (!areMultiPagesEnabledForUser) {
    return;
  }

  if (isPageNavigationBlocked()) {
    return;
  }

  const currentState = window.PMW.redux.store.getState().posterEditor.mobilePageSelectionModeState;

  if (currentState !== MobilePageSelectionModeState.TRANSITIONING) {
    window.PMW.redux.store.dispatch(setMobilePageSelectionModeState(MobilePageSelectionModeState.TRANSITIONING));
  }
};

export const exitMobilePageSelectionMode = (): void => {
  if (!isEditorMobileVariant()) {
    return;
  }

  const areMultiPagesEnabledForUser = window.PMW.isMultipageAvailable;
  if (!areMultiPagesEnabledForUser) {
    return;
  }

  const currentState = window.PMW.redux.store.getState().posterEditor.mobilePageSelectionModeState;

  if (currentState !== MobilePageSelectionModeState.INACTIVE) {
    window.PMW.redux.store.dispatch(setMobilePageSelectionModeState(MobilePageSelectionModeState.INACTIVE));
  }
};

export const activateMobilePageSelectionMode = (): void => {
  if (!isEditorMobileVariant()) {
    return;
  }

  const areMultiPagesEnabledForUser = window.PMW.isMultipageAvailable;
  if (!areMultiPagesEnabledForUser) {
    return;
  }

  if (isPageNavigationBlocked()) {
    return;
  }

  window.posterEditor?.whiteboard?.clearSelection();

  const currentState = window.PMW.redux.store.getState().posterEditor.mobilePageSelectionModeState;

  if (currentState !== MobilePageSelectionModeState.ACTIVE) {
    openPageOptionsModal();
    window.PMW.redux.store.dispatch(setMobilePageSelectionModeState(MobilePageSelectionModeState.ACTIVE));
  }
};

export const openPageOptionsModal = (): void => {
  if (!isEditorMobileVariant()) {
    return;
  }

  const areMultiPagesEnabledForUser = window.PMW.isMultipageAvailable;
  if (!areMultiPagesEnabledForUser) {
    return;
  }

  if (isPageNavigationBlocked()) {
    return;
  }

  openPosterEditorPageOptionsModal();
};
